function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M22.491,14.3a2.523,2.523,0,0,1,1.619-2.354A10,10,0,0,0,22.9,9.035a2.557,2.557,0,0,1-1.026.22,2.518,2.518,0,0,1-2.3-3.544A9.972,9.972,0,0,0,16.659,4.5a2.521,2.521,0,0,1-4.708,0A10,10,0,0,0,9.035,5.71a2.518,2.518,0,0,1-2.3,3.544,2.474,2.474,0,0,1-1.026-.22A10.223,10.223,0,0,0,4.5,11.956a2.523,2.523,0,0,1,.005,4.708,10,10,0,0,0,1.21,2.916A2.519,2.519,0,0,1,9.04,22.9a10.061,10.061,0,0,0,2.916,1.21,2.517,2.517,0,0,1,4.7,0A10,10,0,0,0,19.57,22.9a2.521,2.521,0,0,1,3.324-3.325,10.061,10.061,0,0,0,1.21-2.916A2.535,2.535,0,0,1,22.491,14.3Zm-8.14,4.08A4.085,4.085,0,1,1,18.436,14.3,4.084,4.084,0,0,1,14.351,18.385Z",
  transform: "translate(-4.5 -4.5)"
});

function SvgGear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.61,
    height: 19.615,
    viewBox: "0 0 19.61 19.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.60a445f6.svg";
export { ForwardRef as ReactComponent };